import axios from 'axios';
import { url } from '../../axiosInstance';
import * as actionType from '../store/action';

export const CollectSiteProductGet = () => {
    return dispatch => {
        axios.get(`${url}CollectSite/GetCollectSiteProduct`, {
            headers: {
                'Authorization': `bearer ${localStorage.token}`,
                "Access-Control-Allow-Origin": "*"
            }
        }).then(x => {
            if (x.data) {
                dispatch({ type: actionType.SET_ALL_PRODUCT, payload: x.data })
            }
        })
    }
}

export const CollectSiteProductSetOrder = (orderId) => {
    return dispatch => {
        axios.get(`${url}CollectSite/CollectSiteProductSetOrder?orderId=${orderId}`, {
            headers: {
                'Authorization': `bearer ${localStorage.token}`,
                "Access-Control-Allow-Origin": "*"
            }
        }).then(x => {
            if (x.data) {
                dispatch({ type: actionType.SET_ALL_PRODUCT, payload: x.data })
            }
        })
    }
}

export const CollectSiteProductRemoveProduct = (product, quantity) => {
    return (dispatch) => {
        const ProductMkt = product.ProductMkt ? product.ProductMkt : product.Mkt;
        if (ProductMkt > 100) {
            const val = {
                ProductMkt,
                Quantity: quantity,
                Price: product.Price,
            };
            axios.post(`${url}CollectSite/RemoveProductFromCart`, val, {
                headers: {
                    'Authorization': `bearer ${localStorage.token}`,
                    "Access-Control-Allow-Origin": "*"
                }
            })
                .then(x => {
                    if (x.data.ReturnNew) {
                        // אם יש תשובה מ-API של פריטים חדשים, עדכון כל המוצרים בסל
                        dispatch({ type: actionType.SET_ALL_PRODUCT, payload: x.data });
                    } else {
                        // אם לא, הסר את המוצר הספציפי מהסל
                        dispatch({ type: actionType.REMOVE_PRODUCT_FROM_CART, payload: { data: x.data, quantity, product } });
                    }
                })
                .catch(() => console.log("error"));
        }
    }
};

export const CollectSiteProductSetProduct = (product, Quantity ,stationId) => {
    
    return (dispatch) => {
        const ProductMkt = product.ProductMkt ? product.ProductMkt : product.Mkt;
        if (ProductMkt > 100) {
            const val = {
                ProductMkt,
                Quantity,
                Price: product.Price,
            };
            axios.post(`${url}CollectSite/SetProduct?stationId=${stationId}`, val, {
                headers: {
                    'Authorization': `bearer ${localStorage.token}`,
                    "Access-Control-Allow-Origin": "*"
                }
            })          
                .then(x => {
                    if (x.data.ReturnNew) {
                        dispatch({ type: actionType.SET_ALL_PRODUCT, payload: x.data })
                    }
                    else {
                        dispatch({ type: actionType.ADD_PRODUCT_IN_CART, payload: { data: x.data, Quantity, product } })
                    }
                })
                .catch (() => console.log("error"))
        }
    }
}

export const CancelError = () => {
    return dispatch => {
        dispatch({ type: actionType.CANCEL_ERROR })
    }
}

export const clearCart = () => {
    return dispatch => {
        dispatch({ type: actionType.CLEAR_CARD })
    }
}